<template>
  <div id="container" v-loading.fullscreen="disabled">
    <div class="full_layout">
      <div class="shopping_cart">
        <div class="shopping_box">
          <!-- checkout address -->
          <div class="checkout_box">
            <h3>{{$t('base.shipTo')}}<span class="text_blue" style="font-weight: normal;" @click="addChange('','new')">+{{ $t('base.addNewAddress') }}</span></h3>
            <!-- <div class="BusinessType" v-if="BusinessType==2">Cards will be sent to Card Hobby Office in Shanghai China for international
              transaction. You can view them in Oversea Warehouse.</div> -->
            <ul class="address_list" v-if="address!=''||orderAdd!=''">
              <!-- 订单生成后地址 -->
              <li v-if="orderAdd&&again!=undefined" class="on">
                <div class="choose_address">
                  <div class="on_Default" v-if="orderAdd.IsDefault">{{$t('base.default')}}</div>
                  <div>
                    <span>{{orderAdd.UserName}}</span>
                    ({{orderAdd.Country}})
                  </div>
                  <div class="line_txt2" :title="((orderAdd.StreetAddress !=null ? orderAdd.StreetAddress+',':'')+(orderAdd.StreetAddress2 !=null&&orderAdd.StreetAddress2!='' ? orderAdd.StreetAddress2+',':'')+(orderAdd.City !=null ? orderAdd.City+',':'')+(orderAdd.StateCode !=null ? orderAdd.StateCode+',':'')+orderAdd.ZipCode)">
                    <span>{{orderAdd.StreetAddress !=null ? orderAdd.StreetAddress+', ':''}}</span>
                    <span v-if="orderAdd.StreetAddress2 !=null&&orderAdd.StreetAddress2!=''">{{orderAdd.StreetAddress2 !=null&&orderAdd.StreetAddress2!='' ? orderAdd.StreetAddress2+', ':''}}</span>
                    <span>{{orderAdd.City !=null ? orderAdd.City+', ':''}}</span>
                    <span>{{orderAdd.State !=null ? orderAdd.State+', ':''}}</span>
                    <span>{{orderAdd.ZipCode}}</span>
                  </div>
                  <div>{{orderAdd.Phone}}</div>
                </div>
              </li>
              <!-- 订单未生成时地址或者订单生成后需要切换的地址 -->
              <li v-for="(item,index) in address" v-if="index<10" :class="isAdd==index&&again==undefined?'on':''">
                <div class="choose_address" @click="addCheck(item,index)">
                  <div class="on_Default" v-if="item.IsDefault">{{$t('base.default')}}</div>
                  <div><span>{{item.UserName}}</span> ({{item.Country}})</div>
                  <div class="line_txt2" :title="((item.StreetAddress !=null ? item.StreetAddress+',':'')+(item.StreetAddress2 !=null&&item.StreetAddress2!='' ? item.StreetAddress2+',':'')+(item.City !=null ? item.City+',':'')+(item.StateCode !=null ? item.StateCode+',':'')+item.ZipCode)">
                    <span>{{item.StreetAddress !=null ? item.StreetAddress+', ':''}}</span>
                    <span v-if="item.StreetAddress2 !=null&&item.StreetAddress2!=''">{{item.StreetAddress2 !=null&&item.StreetAddress2!='' ? item.StreetAddress2+', ':''}}</span>
                    <span>{{item.City !=null ? item.City+', ':''}}</span>
                    <span>{{item.State !=null ? item.State+', ':''}}</span>
                    <span>{{item.ZipCode}}</span>
                  </div>
                  <div>{{item.Phone}}</div>
                </div>
                <span class="change text_blue chage_address" v-if="isAdd==index&&again==undefined" @click="addChange(item,index)">{{$t('base.edit')}}</span>
                <span class="change text_blue chage_address" v-if="again!=undefined" @click="addChange(item,index)">{{$t('base.edit')}}</span>
              </li>
            </ul>
          </div>
          <!-- checkout pay -->
          <div class="checkout_box">
            <h3>{{$t('base.payWith')}}</h3>
            <ul class="pay_list">
              <li :class="{'on':checkPay=='stripe'}" @click="payCheck()">
                <el-image class="like_img" src="../../static/images/stripe.png" fit="contain"></el-image>
              </li>
            </ul>
            <!-- <ul class="pay_list" v-if="antPayChannelsList.length>0">
              <li v-if="item.PaymentMethodCategory!='CARD'" :class="{'on':paymentMethodType==item.PaymentMethodType}" @click="antPayCheck(item)" v-for="(item,index) in antPayChannelsList" :key="index">
                <el-image v-if="item.Logo" class="like_img" :src="item.Logo.LogoUrl" fit="contain"></el-image>
                <span v-else class="PaymentMethodCategory">{{item.PaymentMethodCategory}}</span>
              </li>
            </ul> -->
            <!-- <div v-if="isOtherPay" class="others"><span @click='getAntPay()'>Others</span></div> -->
          </div>
          <!-- checkout detail -->
          <div class="checkout_box">
            <h3>{{$t('base.reviewItemsShipping')}}</h3>
            <div class="table_head">
              <div class="commod head_box">{{ $t('base.commodity') }}</div>
              <div class="head_box">{{ $t('base.quantity') }}</div>
              <div class="head_box">{{ $t('base.itemPrice') }}</div>
            </div>
            <div class="review_list" v-if="list">
              <div v-for="(item,index) in list.Details">
                <div class="shopping_list">
                  <div class="like_box">
                    <el-image class="like_img" :src="item.Imgs[0]" fit="contain"></el-image>
                    <p class="line_txt4">
                      <span class="line_txt4">{{item.Title}}</span>
                      <span class="ConditionName">{{item.ConditionName}}</span>
                    </p>
                  </div>
                  <div class="list_price">
                    {{item.Num?item.Num:item.QuantitySold}}
                  </div>
                  <div class="list_price ">
                    <span>{{item.Currency}} {{item.NewPrice?formatAmount(item.NewPrice):formatAmount(item.RealLowestPrice)}}</span>
                    <!-- <span>{{item.Currency}} {{item.NewPrice?formatAmount(item.NewPrice):formatAmount(item.RealLowestPrice)}}</span> --> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Checkout" v-if="list">
          <div class="check_list">
            <span>{{list.Details.length != 1?$t('base.items') :$t('base.item')}} ({{list.Details.length}})</span>
            <span class="price">{{areaSymbol}} {{formatAmount(total)}}</span>
          </div>
          <div class="check_list Shipping_list">
            <span class="Shipping_ZipCode">{{ $t('base.shippingTo') }} {{orderAdd.State||checkAdd.State}}</span>
            <span class="price price_s" v-if="postPrice>0">{{areaSymbol}} {{formatAmount(postPrice)}}</span>
            <span class="price price_s" v-if="postPrice<=0">{{postageMoney}}</span>
          </div>
          <div class="check_list">
            <span>{{$t('base.stateTax')}}</span>
            <span class="price price_s">{{areaSymbol}} {{formatAmount(list.tax)}}</span>
          </div>
          <div class="check_list check_list_all">
            <span>{{ $t('base.orderTotal') }}</span>
            <span>{{areaSymbol}} {{again!=undefined?list.subtotal:(totalPrice(list.tax,totalPrice(list.subtotal,postPrice)))}}</span>
          </div>
          <div class="check_list">
            <i18n path="alert.agreementAPrivacy" tag="p" class="text_gray">
              <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">{{$t('base.service')}}</router-link>
              <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">{{$t('base.privacy')}}</router-link>
            </i18n>
          </div>
          <el-button class="check_btn" type="primary" :disabled="disabled" @click='payOrder()' v-if="again!=undefined">
            {{$t('base.confirmPay')}}</el-button>
          <el-button class="check_btn" type="primary" :disabled="disabled" @click='addOrder' v-else>
            {{$t('base.confirmPay')}}</el-button>
          <span class="text_gray finish">{{$t('alert.checkoutOn')}} {{checkPayUpper}}</span>
        </div>
      </div>
    </div>
    <!-- edit address -->
    <get-address v-if="dialogVisible" :dialogVisible.sync="dialogVisible" :checkAdd.sync="checkAdd" :isNew.sync="isNew" :getAreas.sync="getAreas" :userInfo.sync="userInfo" :type='0' />
    <order-check v-if="dislogType.ordercheck" dialogClass="taxBox" :domVisible="dislogType.ordercheck" @closeDialog="closeDialog" @addOrder="addOrder" :title="$t('alert.sureBuyItem')" :orderCheckList="orderCheckList" :list="list" />
  </div>
</template>
<script>
//从app.vue 往 Child.vue中传递信息。
import bus from '@/api/bus';
import GetAddress from "@/components/dialog/orderaddress"; // 收货地址
import OrderCheck from "@/components/dialog/ordercheck"; // 一口价下单二次确认

import { getInfo, addressList, numAdd, setInfo, isNumber, formatAmount, priceExchange, numMulti, numSub, goPay, GetWorldUSD, setPayList } from "@/api/public";
import qs from 'qs'
export default {
  name: 'index',
  inject: ['reload'],
  components: {
    GetAddress,
    OrderCheck
  },
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
      orderCheckList: null,
      areaSymbol: this.$store.state.areaSymbol,
      isOnly: false,
      userInfo: '',
      isNew: false,
      CouponPrice: '0',
      CouponID: '',
      Coupon: '',
      disabled: false,
      dialogVisible: false,
      address: [],
      getAreas: '',
      checkAdd: '',
      newAdd: '',
      orderAdd: '',
      orderAddId: 0,
      isAdd: '',
      checkPay: 'stripe',
      checkPayUpper: 'Stripe', //'Authorize.Net',
      payChannelsList: [],
      antPayChannelsList: [],
      paymentMethodType:'',
      isOtherPay:true,
      payChannels: this.$enumInfo.payChannels,
      payEnum: this.$enumInfo.paylist,
      IsGuarantee: 6,
      Subtotal: 0,
      num: 1,
      value: '',
      list: '',
      cid: 0,
      DomesticCustom: [],
      BusinessType: '',
      postPrice: 0,
      postageMoney: '',
      again: '',
      tolist: '',
      total: 0,
      oldTotal: 0, //折扣前总价
      TotalCount: 0,
      // ifNoCouons: 'No Coupons',
      IfDefault: true,
      passForm: {
        Country: "US",
        UserName: '',
        StreetAddress: '',
        StreetAddress2: '',
        City: '',
        StateCode: '',
        State: '',
        ZipCode: '',
        Phone: '',
      }
    }
  },
  watch: {
    '$route': 'getPath',
    'list': {
      handler(val) {
        // console.log(val, 'vallist')
        this.total = isNumber(this.list.total);
        //优惠前总价计算
        if (this.list.DiscountsPrice > 0 && this.again != undefined) {
          this.oldTotal = numAdd(this.total, this.list.DiscountsPrice)
          this.oldTotal = numSub(this.oldTotal, this.postPrice)
        }
      }
    },
  },
  mounted() {},
  created() {
    this.userInfo = getInfo()
    // GetWorldUSD()
    // this.isPayChannels()
    bus.$emit('headerTitle', this.$t('title.checkout'));
    this.list = window.sessionStorage.getItem('check');
    if (this.list) {
      this.list = JSON.parse(this.list);
      this.total = this.list.total ? this.list.total : 0
      this.tolist = this.list;
    }
    this.isAgain()
  },
  filters: {},
  methods: {
    formatAmount(obj) {
      return formatAmount(obj)
    },
    isPayChannels() {
      let that = this
      let data = { areaCode: that.userInfo.MemberSource }
      that.$get(that.$interface.GetPayChannels, data).then(res => {
        if (res.Result != 0) {
          let data = res.Data
          data = setPayList(data, that.userInfo)
          // res.Data.map(item => {
          //   item.ChannelName = item.ChannelName.toLowerCase()
          // })
          that.checkPay = data[0].LowerName
          that.checkPayUpper = data[0].ChannelName
          that.IsGuarantee = that.payEnum[that.checkPay]
          that.payChannelsList = data
        } else {
          that.checkPay = 'stripe'
          that.checkPayUpper = 'Stripe'
          that.IsGuarantee = that.payEnum[that.checkPay]

        }
      }).catch(res => {
        that.checkPay = 'stripe'
        that.checkPayUpper = 'Stripe'
        that.IsGuarantee = that.payEnum[that.checkPay]
      })
    },
    totalPrice(total, post) {
      return numAdd(isNumber(post), isNumber(total)).toLocaleString()
    },
    GetTax(obj) {
      let that = this
      let data = { StateName: obj.State, AreaCode: that.userInfo.MemberSource }
      that.$get(that.$interface.getTax, data).then(res => {
        if (res.Result != 0) {
          let fee = 0
          if (res.Data) {
            fee = res.Data.Fee
          }
          that.list.tax = numMulti(that.list.total, fee).toFixed(2)
        }
      })
    },
    // 判断是否有订单号
    isAgain() {
      this.again = this.$route.params.id;
      //again:''
      let that = this;

      this.getAddressList();
      this.getAreasList();
      if (this.again != undefined) {
        this.GetOrder()
      } else {
        this.areaSymbol = this.list.Details[0].Currency
        // if (this.tolist.to === 'buynow') {
        //   this.GetMyCoupon()
        // } else {
        //   if (this.tolist.Details.length == 1 && this.tolist.couponMemberID[0] == 0) {
        //     this.isOnly = true
        //     this.GetMyCoupon()
        //   }
        // }
        //this.cid = this.list.Details[0].AddressVersionCode
      }

    },

    //设置支付方式
    payCheck() {
      let that=this
          that.checkPay = 'stripe'
          that.checkPayUpper = 'Stripe'
          that.IsGuarantee = that.payEnum[that.checkPay]
      that.paymentMethodType=''
    },
    // 获取蚂蚁金融的支付方式
    getAntPay(type){
      let that=this
      let price=that.totalPrice(that.list.tax,that.totalPrice(that.list.subtotal,that.postPrice))
      if(that.again!=undefined){
        price=that.list.subtotal
      }
      let data={currency:that.areaSymbol,deviceType:1,userRegion:that.userInfo.MemberSource,amount:price}

        that.disabled = true;
      that.$post(that.$interface.GetAntPayChannels,data).then(res=>{
        if(res.Result){
          that.antPayChannelsList=res.Data
          that.isOtherPay=!that.isOtherPay
        }else{
            that.$message({
              type: 'error',
              message: res.Msg
            });
        }
        that.disabled = false;
      })
    },
    // 修改蚂蚁支付方式
    antPayCheck(item){
      let that=this
      that.paymentMethodType=item.PaymentMethodType
      that.checkPayUpper=item.PaymentMethodCategory
      that.checkPay = 'other';
      that.IsGuarantee = that.payEnum['other']
    },
    // 获取订单详情
    GetOrder() {
      let that = this;
      let data = { memberid: that.userInfo.MappingUserId, orderId: that.again }
      this.$get(this.$interface.GetStoreOrderById, data).then(res => {
        if (res.Result != 0) {
          let data = res.Data
          let add = data.AddressMsg.AddressDetail
          let detail = {}

          that.areaSymbol = data.Currency
          //that.checkPay='Stripe'
          if (add) {
            if (add.indexOf('()') > 0) {
              // var a=add1.indexOf('()')
              // console.log(add1,a,'add2',add1.substring(0,a))
              //var reg=new RegExp()
              add = add.replace(/\(\)/g, "")
              add = [add]
              // console.log(add, 'add1')
            } else {
              if (add.indexOf(')') != -1) {
                add = add.replace(")", "")
                add = add.replace("(", "|")
              }
              add = add.split("|")
              // console.log(add, add[0], 'add2')
            }
          }
          // 重组地址信息
          let result = {
            UserName: data.AddressMsg.Consignee,
            Country: data.AreaCode,
            StreetAddress: add[0] ? add[0] : add,
            StreetAddress2: add[1] ? add[1] : '',
            ZipCode: data.AddressMsg.PostalCode,
            City: data.AddressMsg.CityName,
            State: data.AddressMsg.ProvinceName,
            Phone: data.AddressMsg.Telephone,
            StateCode: '',
          }
          detail = { orderId: data.Id, total: data.PriceTotal, subtotal: data.OrderAmount, tax: data.TaxAmount, Details: [] }
          data.CommodityList.map(item => {
            let it = {
              AreaCode: item.AreaCode,
              StoreName: data.StoreName,
              StoreLogo: data.StoreLogo,
              CommodityId: item.CommodityId,
              ConditionId: item.ConditionId,
              Num: item.Quantity,
              NewPrice: item.Price,
              ConditionName: item.GFCommodityBody.Conditions[0].ConditionName,
              Imgs: item.GFCommodityBody.Imgs,
              Title: item.GFCommodityBody.Title,
              Currency: data.Currency
            }
            detail.Details.push(it)
          })
          this.list = detail
          that.postPrice = data.Postage

          if (data.PostageType == '1') {
            that.postageMoney = that.$t('base.payOnDelivery')
          } else if (data.PostageType == '2') {
            that.postageMoney = that.$t('base.freeShipping')
          } else {
            that.postageMoney = ''
          }

          this.orderAdd = result;
          this.setOrderAddressList(result)
          if (this.again != undefined) {
            if (this.getAreas) {
              this.getAreas.map(item => {
                if (result.State == item.EName) {
                  result.StateCode = item.Code
                }
              })
            }
          }
          that.disabled = false
        }

      })
    },
    //去重收货地址
    setOrderAddressList(obj) {
      let that = this
      let add = that.address
      add.map((res, i) => {
        let oldadd = res.City + res.Country + res.Phone + res.State + res.StreetAddress + res.StreetAddress2 + res.UserName + res.ZipCode
        let newadd = obj.City + obj.Country + obj.Phone + obj.State + obj.StreetAddress + obj.StreetAddress2 + obj.UserName + obj.ZipCode
        //console.log(oldadd, '|', newadd, oldadd == newadd)
        if (oldadd == newadd) {
          if (res.IsDefault) {
            that.orderAdd.IsDefault = true
          }
          that.orderAddId = res.Id
          that.address.splice(i, 1)
        }
      })


      if (that.again != undefined) {
        if (that.payChannelsList.length <= 1 && that.payChannelsList.length > 0) {

          var ChannelName = that.payChannelsList[0].LowerName
          if (that.checkPay != ChannelName) {
            that.payCheck(that.payChannelsList[0])
          }

        }
      }
      //console.log(that.address, obj, 'that.address')
    },
    //新增订单and 更新订单
    addOrder() {
      let that = this

      if (that.again != undefined) {
        that.disabled = true;
        that.payOrder()
        //goPay(this.checkPay,'pay',('?id=' + orderid))
        //window.location.href = this.$interface.pay + '?id=' + that.again
      } else {
        // that.disabled = true;
        //判断是否从一口价进来的checkout
        if (that.tolist.to === 'buynow') {
          //console.log(this.tolist.to, 'this.tolist.to')
          that.setOrder()
        } else {
          that.getCart()
        }
      }
    },
    // 验证购物车与session中商品是否有交集
    getCart() {
      let that = this
      let data = { BuyerId: this.userInfo.MappingUserId, AreaCode: this.userInfo.MemberSource, PageIndex: 1, PageSize: 99 }
      this.$get(this.$interface.GetCartList, data).then(res => {
        if (res.Result != 0) {
          let list = that.list.commodityIds
          let result = res.Data
          if (result.length > 0) {
            let newRes = []
            let isNo = 0;
            result.map(r => {
              if (r.Num > 0) {
                newRes.push({ CommodityId: r.CommodityId, ConditionId: r.ConditionId })
              }
            })
            // 购物车与session中商品是否有交集
            isNo = list.filter(v => {
              //console.log(newRes, v, newRes.some(Res => Res.CommodityId === v.CommodityId && Res.ConditionId === v.ConditionId), 'newRes.includes(v)')
              if (newRes.some(Res => Res.CommodityId === v.CommodityId && Res.ConditionId === v.ConditionId)) {
                return v
              }
            })
            // 有交集重组session中商品
            if (isNo != 0) {
              let newCommodityIds = []
              let newCuantitySold = []
              let newCouponMemberID = []
              let newDetails = []
              //CommodityIds: that.list.commodityIds, QuantitySold: that.list.cuantitySold, couponMemberID: that.list.couponMemberID
              isNo.map(item => {
                that.list.Details.map(r => {
                  if (item.CommodityId == r.CommodityId && item.ConditionId == r.ConditionId) {
                    newCommodityIds.push({ CommodityId: r.CommodityId, ConditionId: r.ConditionId })
                    newCuantitySold.push(r.Num)
                    newCouponMemberID.push(r.Coupon || r.CouponID || '')
                    newDetails.push(r)
                  }
                })
              })
              that.list.Details = newDetails
              that.list.commodityIds = newCommodityIds
              that.list.cuantitySold = newCuantitySold
              that.list.couponMemberID = newCouponMemberID
              that.list.total = that.SetSubtotal(that.list.Details)
              that.GetPostPrice(that.checkAdd)
              this.setOrder()
            } else {
              this.$message({
                type: 'error',
                message: 'The order has already been placed'
              });

              that.disabled = false
            }
          } else {

            this.$message({
              type: 'error',
              message: 'The order has already been placed'
            });
            that.disabled = false
            //   this.$message({
            //     type: 'error',
            //     message: '相关商品已生成订单'
            //   });
          }
          //CommodityId
          // let isNo = 0;
          // result.map(r => {
          //   list.map(item => {
          //     if (r.CommodityId == item.CommodityId) {
          //       isNo++
          //     }
          //   })
          // })
        } else {

        }
      })
    },
    //根据选中商品更改总价
    SetSubtotal(obj) {
      //console.log('obj', obj)
      let data = obj
      let totalArray = 0;
      let CouponArray = 0;
      let Subtotal = 0
      data.map(res => {
        //商品合计总价
        totalArray = numAdd(isNumber(totalArray), numMulti(isNumber(res.NewPrice), isNumber(res.Num)))
        //商品合计优惠券总价
        //CouponArray = numAdd(isNumber(CouponArray), isNumber(res.FreeMoney == undefined || res.FreeMoney == null ? 0 : res.FreeMoney))

      })
      // 商品扣除优惠券后总价
      Subtotal = numSub(totalArray, CouponArray) > 0 ? numSub(totalArray, CouponArray) : 0
      return Subtotal
    },
    //提交订单并支付
    setOrder() {
      let that = this
      let addressMsg = {}
      let commodityList = [];
      let areaCode = 'US'
      that.list.Details.map(res => {
        areaCode = res.AreaCode
        commodityList.push({ commodityId: res.CommodityId, conditionId: res.ConditionId, quantity: res.Num })
      })
      let orderList = [{ StoreName: '', StoreLogo: '', AreaCode: areaCode, commodityList: commodityList }]
      addressMsg = {
        addressId: that.checkAdd.Id,
        consignee: that.checkAdd.UserName,
        telephone: that.checkAdd.Phone,
        postalCode: that.checkAdd.ZipCode,
        provinceName: that.checkAdd.State,
        cityName: that.checkAdd.City,
        addressDetail: that.checkAdd.StreetAddress + ("(" + that.checkAdd.StreetAddress2 + ")")
      }
      let data = { MemberId: that.userInfo.MappingUserId, nickName: that.userInfo.NickName, orderRemark: '', areaCode: that.userInfo.MemberSource, isSelfPickup: false, addressMsg, orderList }
      let msg = that.$t('alert.noAddress')
      if (this.address.length <= 0) {
        this.$message({
          type: 'error',
          // message: res.msg
          message: msg
        });
        that.disabled = false
      } else {
        const OrderCreate = function() {
          that.$post(that.$interface.OrderCreate, data).then(res => {
            if (res.Result != 0) {
              let orderid = res.Data.OrderId
              that.payOrder(orderid)
            } else {
              that.$message({
                type: 'error',
                message: res.msg
              });
              that.disabled = false
            }
          })
        }
        that.disabled = true;
        if (that.dislogType.ordercheck) {
          that.dislogType.ordercheck = !that.dislogType.ordercheck
          OrderCreate()
        } else {
          that.orderCheckList = { "areaSymbol": that.areaSymbol, "ServiceFee": "", "TaxServiceFee": formatAmount(that.list.tax), "postPrice": formatAmount(that.postPrice), "postageMoney": that.postageMoney, "totalPrice": (that.totalPrice(that.list.tax, that.totalPrice(that.list.subtotal, that.postPrice))), "shipping": (that.orderAdd.State || that.checkAdd.State), 'type': 'store' }
          that.dislogType.ordercheck = !that.dislogType.ordercheck
          that.disabled = false;
        }
        // this.$confirm('<div style="text-align: center;">' + that.$t('alert.sureBuyItem') + '</div>', that.$t('base.hint'), {
        //   lockScroll: false,
        //   dangerouslyUseHTMLString: true,
        //   confirmButtonText: this.$t('base.pay'),
        //   cancelButtonText: this.$t('base.cancel')
        // }).then(() => {
        //   OrderCreate()
        // }).catch(() => {});


      }
    },
    // 支付http://stripepay
    payOrder(id) {
      this.disabled = true
      var orderid = id && id != null ? id : this.again
      if(this.checkPay=='stripe'){
        goPay('Storepay', ('?id=' + orderid + '&FromDevice=web'))
      }else if(this.checkPay=='other'){
        goPay('antSpay', ('?Id=' + orderid+'&PaymentMethodType='+this.paymentMethodType+'&DeviceType=1'))
      }
      // this.$router.push({
      //   path: '/creditcards?id=' + orderid
      // })

    },
    // 获取邮费
    GetPostPrice(obj, type) {
      let that = this;
      let orderPrice = isNumber(that.list.total)
      let data = { AreaCode: obj.Country, provinceName: obj.State }
      that.$get(this.$interface.GetPostageByProvinceName, data).then(res => {

        if (res.Result != 0) {
          // Cost: 20
          // CostType: 2
          // DetailMinimumAmount: 0
          // FreeDelivery: false
          // ProvinceId: "5245018437058954849"
          // ProvinceName: "Oklahoma"

          // <span v-if="domesticCustom.CostType==1">{{$t('base.payOnDelivery')}}</span>
          // <span v-if="domesticCustom.CostType!=1&&domesticCustom.FreeDelivery&&domesticCustom.DetailMinimumAmount<=0">{{$t('base.freeShipping')}}</span>
          // <span v-if="domesticCustom.CostType!=1&&domesticCustom.FreeDelivery&&domesticCustom.DetailMinimumAmount>0">{{areaSymbol}} {{domesticCustom.Cost}}</span>
          // <span v-if="domesticCustom.CostType!=1&&!domesticCustom.FreeDelivery">{{areaSymbol}} {{domesticCustom.Cost}}</span>
          let data = res.Data
          that.postPrice = 0
          if (data.CostType != 1) {
            if (data.FreeDelivery) {
              if (orderPrice >= data.DetailMinimumAmount) {
                that.postageMoney = that.$t('base.freeShipping')
              } else {
                that.postPrice = data.Cost
              }
            } else {
              that.postPrice = data.Cost
            }
          } else {
            that.postageMoney = that.$t('base.payOnDelivery')
          }
          // this.postPrice = res.data.USPostMoney != null ? res.data.USPostMoney : 0
          // this.postageMoney = res.data.PostageMoneyStr
        }
        // console.log(res, 'ress')
      })

    },
    //获取地址列表 type新添加地址
    getAddressList(type) {
      let that = this
      addressList().then(res => {
        setInfo('Count', res.Count ? res.Count : 0)
        if (res.Result != 0) {
          this.address = res.Data
          if (type) {
            var endLength = this.address.length - 1
            this.GetPostPrice(this.address[endLength])
            this.checkAdd = this.address[endLength]
            //console.log(this.checkAdd, '11111')
            this.isAdd = endLength;
            if (that.again != undefined) {
              that.setOrderAddressList(that.orderAdd);
            }
          } else {
            if (that.again != undefined) {
              //订单列表或详情进入 去重收货地址
              if (that.orderAdd) {
                that.setOrderAddressList(that.orderAdd);
                //that.GetServiceFee(2, that.orderAdd)
              }
            } else {
              //this.GetPostPrice(this.address[0])
              this.checkAdd = this.address[0]
              this.isAdd = 0;
              this.GetPostPrice(this.checkAdd)
              this.GetTax(this.checkAdd)
              // if (this.isAdd > 0) {
              //   this.GetPostPrice(this.address[this.isAdd])
              //   this.checkAdd = this.address[this.isAdd]
              //   console.log(this.checkAdd, '22222')
              // } else {
              //   if (res.Count.length > 1) {
              //     this.address.map((val, i) => {
              //       if (val.IsDefault) {
              //         //console.log(val)
              //         this.GetPostPrice(val)
              //         this.checkAdd = val
              //         console.log(this.checkAdd, '333333')
              //         this.isAdd = i;
              //       }
              //     })
              //   } else {
              //     this.GetPostPrice(this.address[0])
              //     this.checkAdd = this.address[0]
              //     console.log(this.checkAdd, '44444')
              //     this.isAdd = 0;
              //   }
              // }
            }
          }
        }
      })
    },
    //获取地区列表
    getAreasList() {
      let that = this;
      let data = { code: that.userInfo.MemberSource }
      this.$get(this.$interface.GetAreas, data).then(res => {
        if (res.Result != 0) {
          that.getAreas = res.Data;
        }
      })
    },
    //设置地址选中
    addCheck(obj, val) {
      let that = this
      if (this.again != undefined) {
        //更新订单
        this.disabled = true;
        let addressMsg = {
          addressId: obj.Id,
          consignee: obj.UserName,
          telephone: obj.Phone,
          postalCode: obj.ZipCode,
          provinceName: obj.State,
          cityName: obj.City,
          addressDetail: obj.StreetAddress + ("(" + obj.StreetAddress2 + ")")
        }
        let data = { memberId: that.userInfo.MappingUserId, orderId: that.list.orderId, isSelfPickup: false, addressMsg }
        // console.log(obj, val, 'obj, val')

        this.$post(that.$interface.UpdateStoreAddress, data).then(res => {
          if (res.Result != 0) {

            that.reload()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            });
            this.addloading = false
          }
        })
      } else {
        if (val != this.isAdd) {
          this.isAdd = val;
          this.checkAdd = obj
          // console.log(this.checkAdd, '55555')
          this.GetPostPrice(obj)
          this.GetTax(obj)
        }
      }
    },
    //新增地址
    addChange(obj, val) {
      this.dialogVisible = true
      //console.log(obj, '1231231231')
      if (val == 'new') {
        this.isNew = true;
        this.newAdd = this.checkAdd;

        this.checkAdd = this.passForm;
        this.IfDefault = false;
      } else {
        this.isNew = false;
        this.checkAdd = obj;
        this.IfDefault = true;
      }
    },
    //保存地址
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled = true
          let url = this.$interface.SaveAddresses
          let data = {
            "memberId": that.userInfo.Id,
            "country": that.checkAdd.Country,
            "userName": that.checkAdd.UserName,
            "streetAddress": that.checkAdd.StreetAddress,
            "streetAddress2": that.checkAdd.StreetAddress2,
            "city": that.checkAdd.City,
            "stateCode": that.checkAdd.StateCode,
            "state": that.checkAdd.State,
            "zipCode": that.checkAdd.ZipCode,
            "phone": that.checkAdd.Phone
          }
          if (!this.isNew) {
            url = this.$interface.UpdateAddresses;
            data.id = that.checkAdd.Id
            data.isDefault = that.checkAdd.IsDefault
          }
          this.$post(url, data).then(res => {
            if (res.Result != 0) {
              this.getAddressList(this.isNew);
              that.dialogVisible = false
              that.disabled = false
              that.$refs[formName].resetFields();
            } else {
              that.disabled = false
              this.$message({
                type: 'error',
                message: res.Msg
              });
            }
          })
          //console.log(url, data)
        }
      });
      //this.dialogVisible = false
    },
    //取消保存地址
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.checkAdd = this.newAdd;
      this.dialogVisible = false
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
      this.disabled = false;
    }
  },
  //离开页面后
  destroyed() {

    //alert(2);
  }
}

</script>
<style scoped>
@import "../../../static/css/paycart.css";

.shopping_cart {
  margin: 40px 0;
}

.checkout_box h3 {
  font-size: 24px;
  line-height: 1;
  margin: 0 0 16px;
  display: flex;
}

.checkout_box h3>span {
  font-size: 14px;
  margin-top: 9px;
  margin-left: 12px;
  cursor: pointer;
}

.shopping_box {
  border: none;
}

.shopping_list {
  width: 100%;
  padding: 8px 12px;
}

.shopping_list .like_box {
  display: flex;
  position: relative;
  width: 525px;
}

.shopping_list .like_box p {
  width: 425px;
}

.shopping_list .list_price {
  width: 120px;
  text-align: right;
  padding: 0 5px;
}

.avatar_box {
  display: flex;
  height: 40px;
  line-height: 40px;
  background-color: #f7f7f7;
  padding: 0 12px;
}

.avatar {
  width: 16px;
  height: 16px;
  line-height: 16px;
  margin-top: 12px;
  margin-right: 5px;
}

.review_list {
  border: 1px solid #e0e0e0;
  margin-top: 20px;
}

.table_head {
  height: 48px;
  line-height: 48px;
  display: flex;
  background-color: #f7f7f7;
  border-bottom: 1px solid #e0e0e0;
}

.head_box {
  width: 150px;
  padding: 0 12px;
  text-align: right;
}

.commod {
  width: 545px;
  padding-left: 110px;
  text-align: left;
}

.address_list,
.pay_list {
  display: flex;
  flex-wrap: wrap;
}

.address_list li {
  height: 145px;
  border: 2px dashed #e0e0e0;
  margin-right: 8px;
  margin-bottom: 32px;
  padding: 0;
  min-height: 100px;
  width: 278px;
  position: relative;
  cursor: pointer;
}

.address_list li:nth-child(3n) {
  margin-right: 0;
}

.address_list li.on {
  border-color: #5f6dae;
}

.address_list li.on::after {
  content: "";
  border: 15px solid transparent;
  position: absolute;
  border-bottom-color: #5f6dae;
  border-right-color: #5f6dae;
  right: -2px;
  bottom: -2px;
}

.address_list li.on:before {
  content: "";
  border: 1px solid #fff;
  border-top: none;
  border-left: none;
  width: 4px;
  height: 10px;
  position: absolute;
  transform: rotate(45deg);
  bottom: 3px;
  right: 5px;
  z-index: 2;
}

.address_list li>.choose_address {

  box-sizing: border-box;
  padding: 20px;
  width: 278px;
  padding-bottom: 30px
}

.choose_address>div {
  margin-bottom: 10px;
}

.address_list li>div {
  margin-bottom: 10px;
}

.address_list li>div span {
  margin-right: 5px;
}

.address_list li.on .change {
  position: absolute;
  z-index: 2;
  right: 12px;
  bottom: 24px;
  font-size: 14px;
  margin: 0;
  left: auto;
}

.pay_list li {
  border: 1px solid #c8c8c8;
  position: relative;
  cursor: pointer;
  width: 185px;
  margin-right: 20px;
  margin-bottom: 32px;
  height: 38px;
  text-align: center;
}

.pay_list li .like_img {
  width: 100px;
  height: 24px;
  margin-top: 8px;
}

.pay_list li.on {
  border-color: #5f6dae;
  background: #f0f3ff;
}

.pay_list li.on:before {
  content: "";
  border: 1px solid #fff;
  border-top: none;
  border-left: none;
  width: 3px;
  height: 6px;
  position: absolute;
  transform: rotate(45deg);
  bottom: 3px;
  right: 3px;
  z-index: 2;
}

.pay_list li.on::after {
  content: "";
  border: 10px solid transparent;
  position: absolute;
  border-bottom-color: #5f6dae;
  border-right-color: #5f6dae;
  right: -1px;
  bottom: -1px;
}

.info_box {
  width: 240px;
  margin-left: 24px;
}

.address_box {
  width: 100%;
  display: flex;
}

.address_list_box {
  width: 160px;
}

.checkbox_save {
  margin-left: 24px;
}

.dialogBox {
  width: 875px;
}

.set_btn {
  text-align: right;
}

.Checkout {
  font-weight: normal;
}

.check_list_all,
.check_list .price {
  font-weight: bold;
}

.price_s {
  text-align: right;
  /*  font-weight: normal !important;*/
}

.check_list .price {
  text-align: right;
}

.check_list .Couponprice {
  font-weight: bold;
  line-height: 36px;
}

.check_list .info_ipt {
  width: 150px;
}

.finish {
  margin: 10px auto 0;
  display: block;
  text-align: center;
}

.BusinessType {
  font-size: 16px;
  padding-bottom: 20px;
}

.el-select-dropdown li:hover {
  text-decoration: none;
}

.address_box.country {
  margin-bottom: 10px;
  position: relative;
}

.address_box.country .currently {
  position: absolute;
  top: 65px;
  left: 24px;
  font-size: 12px;
  color: #999;
}

.line_txt4 {
  height: 78px;
}

.shopping_list .like_box p .line_txt4 {
  display: -webkit-box;
  height: auto;
}

.ConditionName {
  border-radius: 2px;
  padding: 4px 12px;
  color: #a0a0a0;
  background: #f7f7f7;
  display: inline-block !important;
  margin-top: 10px;
}
.others{
  text-align: center;
  font-size: 16px;
  color:#a0a0a0;
  margin-bottom: 20px;
}
.others>span{
  cursor: pointer;
  position: relative;
}
.others>span:after{
  content: "";
  width: 12px;
  height: 7px;
  background: url(../../../static/images/icon/icon_stroke.svg) no-repeat;
  background-size: contain;
    margin-left: 4px;
    display: inline-block;
}
.PaymentMethodCategory{
  line-height: 35px;
  font-size: 18px;
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/storecheckout.vue